module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead7-4ca1acc6dcba248adb2bfd7e4d3e86be.jpg";